// @core/api/endpoints/secret/list_engines.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListEnginesResponse,
} from '../../../types/secret';

const BASE_PATH = '/secret';

/**
 * List secrets engines
 * Returns all mounted secrets engines, optionally filtered by type or status.
 */
export async function ListEngines(
  params?: {
    cursor?: string | number | boolean;
    direction?: string | number | boolean;
    limit?: string | number | boolean;
    sort?: string | number | boolean;
    status?: string | number | boolean;
    type?: string | number | boolean;
  },
  options?: RequestOptions
): Promise<ListEnginesResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/engines`;
  const requestOptions = options;
  return client.get<ListEnginesResponse>(requestPath, { ...requestOptions, params });
}
